/**
 * 仓库 表单配置处理
 * @author zjs
 * @time 2017-12-11
 */
export default {
    data () {
        return {
            formConfig: [{
                name: "仓库编码",
                type: "ElInput",
                field: "warehouse_code",
                width: "160px",
                json: {
                    span: 6
                }
            }, {
                name: "仓库名称",
                type: "ElInput",
                field: "name",
                width: "160px",
                json: {
                    span: 6
                }
            }, {
                name: "仓库状态",
                type: "LySelect",
                field: "status",
                width: "160px",
                json: {
                    span:6,
                    all: false,
                    data: [{
                        value: '1',
                        label: '启用'
                    }, {
                        value: '0',
                        label: '停用'
                    }]
                },
                default: "1"
            }, 
            // {
            //     name: "业务员可见",
            //     type: "LySelect",
            //     field: "employee_hide",
            //     json: {
            //         all: false,
            //         data: [{
            //             value: '1',
            //             label: '可见'
            //         }, {
            //             value: '0',
            //             label: '不可见'
            //         }]
            //     },
            //     default: "1"
            // }, 
            // {
            //     name: "优先级",
            //     type: 'LySelect',
            //     field: "warehouse_sort",
            //     json: {
            //         all: false,
            //         data: [{
            //             value: "2",
            //             label: "普通"
            //         }, {
            //             value: "1",
            //             label: "优先"
            //         }]
            //     },
            //     default: "2"
            // }, 
            {
                name: "排序顺序",
                type: "LyInputNumber",
                field: "warehouse_sort",
                width: "160px",
                json: {
                    min: 1,
                    span: 6
                }
            }]
        }
    }
}